// 根据 登录获取用户信息
import { apiGet } from './index'

// 获取城市列表
const locationList = (params) => apiGet('/api/training/hospitals/city', params)

// 获取进修中心列表
const educationList = (params) => apiGet('/api/training/hospitals/education', params)

// 获取进修中心详情
const educations = (params) => apiGet(`/api/training/hospitals/${params.hospitalId}`)

// 获取进修中心医生列表
const doctors = (params) => apiGet(`/api/training/hospitals/doctor/${params.hospitalId}`)

export {
  locationList,
  educationList,
  educations,
  doctors
}



// WEBPACK FOOTER //
// ./src/api/education.js